import React, { useState } from 'react';

import { Autocomplete, TextField } from '@mui/material';
import { sortDropdownOptions } from '../utils';

function FilterIsGpo({
    setIsGpo,
	IsGpo,
    setGpoName,
    GpoName
}) {

    const isGpoOptions = sortDropdownOptions(['Yes','No']);

    const [options] = useState(isGpoOptions);
	const [, setFocus] = useState(false);

    function changeProjectType(val) {
		console.log(val);
        setIsGpo(val)
        setGpoName(null)
	}

    return (
        <>
            <div>
                <div className="flex gap-3">
                    <div className="grow">
                        <div className="lightT">
                                             
                                <Autocomplete
                                    disablePortal
                                    isOptionEqualToValue={(option, value) =>
                                        option === value || value === '' || value == null
                                    }
                                    id="combo-box-demo"
                                    options={options}
                                    value={IsGpo}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Is GPO" />
                                    )}
                                    onChange={(event, value) => changeProjectType(value)}
                                    onFocus={() => setFocus(true)}
                                    onBlur={() => setFocus(false)}
                                   
                                />
                            
                          
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FilterIsGpo;
